<script>
  import Header from '@/Elements/Signals/Dark/Headers/Small.svelte';
  import Text from '@/Elements/Signals/Dark/Text.svelte';

  export let item;
</script>

<div class="flex justify-center">
  <div class="relative flex flex-col max-w-xs items-center text-center px-9 py-12 bg-white bg-opacity-80 rounded-sm shadow-md">
    <div class="w-14 h-14 absolute shadow-sm -top-4 -right-4 rounded-md bg-gray-900 bg-opacity-90 p-4">
      <span class="w-full h-full text-white text-opacity-90">
        {@html item.icon}
      </span>
    </div>
    <div class="space-y-3">
      <Header>{item.id}</Header>
      <Text>{item.text}</Text>
    </div>
  </div>
</div>